import React from "react";
import { Sheet } from "react-modal-sheet";

const DiscountTicketContent = ({ children, showModal, onCloseModal }) => {
	return (
		<div>
			<Sheet isOpen={showModal} onClose={() => onCloseModal()} detent="content-height">
				<Sheet.Container
					className="sheet-con"
					style={{
						boxShadow: "0px -2px 4px rgba(0, 0, 0, 0.25)",
						borderRadius: "50px 50px 0px 0px"
					}}
				>
					<Sheet.Header>
						<div className="p-3 mt-2">
							<i
								className="fas fa-times closeIcon d-flex justify-content-end"
								onClick={() => onCloseModal()}
							></i>
							<div className="d-flex justify-content-center align-items-center">
								<h3>Avail Off</h3>
								<img src="/img/off-img.png" alt="off" className="off-img" />
							</div>
						</div>
					</Sheet.Header>
					<Sheet.Content>
						<div className="sheet-body mx-3 mb-5 text-center p-2">{children}</div>
					</Sheet.Content>
				</Sheet.Container>

				<Sheet.Backdrop />
			</Sheet>

			<style jsx>{`
				.closeIcon {
					color: #999999;
					font-size: 24px;
					position: absolute;
					right: 1.2em;
					cursor: pointer;
				}
				h3 {
					font-family: Nunito;
					font-weight: 700;
					font-size: 28px;
					color: #000000;
				}
				.off-img {
					margin: -10px 0px 0 10px;
				}
			`}</style>
		</div>
	);
};

export default DiscountTicketContent;
